import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const ChevronLeft = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.0133 35C26.8213 35 26.6293 34.9265 26.4823 34.781L12.2205 20.5312C12.0795 20.3902 12 20.1997 12 20.0002C12 19.8007 12.0795 19.6102 12.2205 19.4692L26.4823 5.21937C26.7763 4.92688 27.2503 4.92688 27.5443 5.21937C27.8368 5.51337 27.8368 5.98736 27.5443 6.28136L13.8105 20.0002L27.5443 33.719C27.8368 34.013 27.8368 34.487 27.5443 34.781C27.3973 34.9265 27.2053 35 27.0133 35Z"
                fill="currentColor"
            />
        </Icon>
    )
}

ChevronLeft.propTypes = {onClick: PropTypes.func}

export default ChevronLeft
